<template>
  <div>
    <!-- Container-fluid starts-->
    <div
      v-if="sector"
      class="container-fluid"
    >
      <div class="row">
        <!-- Sidebar Column -->
        <div class="col-md-3">
          <ActiveRequestsSidebar
            :active-requests-count-by-country="countryNumberCodes"
            @country-selected="updateCountryCodeNew"
          />
        </div>

        <div class="col-md-9">
          <Breadcrumbs
            main-link="welcome"
            :main="$t('dashboardVue.dashboard')"
            :title="sector.name || 'Yüklənir...'"
          />

          <div class="row mb-3">
            <div :class="{'col-lg-7': sector.logistic, 'col-lg-12': !sector.logistic}">
              <div class="lead font-weight-bold">
                {{ sector.name }}
              </div>
            </div>
            <div class="col-lg-7">
              <div class="md-select-container">
                <Multiselect
                  v-model="selectedCountry"
                  :options="countryOptions"
                  :multiple="true"
                  :placeholder="$t('selectCountry')"
                  :custom-label="customLabel"
                  class="md-select"
                />
              </div>
            </div>
            <div
              v-if="sector.logistic"
              class="col-lg-5"
            >
              <div class="md-select-container">
                <select
                  v-model="requestTypeFilter"
                  class="md-select"
                >
                  <option value="ALL">
                    {{ $t('myRequest.btnSorular') }}
                  </option>
                  <option value="LGI">
                    {{ $t('newRequestPopupContent.logistikInformasiyaSorusu') }}
                  </option>
                  <option value="LOG">
                    {{ $t('newRequestPopupContent.logistikQiymtSorusu') }}
                  </option>
                  <option value="TRS">
                    {{ $t('newRequestPopupContent.trAxtar') }}
                  </option>
                  <option value="TRK">
                    {{ $t('newRequestPopupContent.trElan') }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-7">
              <div class="mb-4">
                <div class="text-left text-lg-left mt-2">
                  <div class="md-tab-group w-100">
                    <button
                      class="md-tab"
                      :class="{
                        'md-tab-inactive': activeTab !== 'request',
                        'md-tab-active': activeTab === 'request'
                      }"
                      @click="activeTab = 'request'"
                    >
                      {{ $t('myCabinetMenu.sorular') }} <span
                        v-if="requestCount('request')"
                        class="ml-2 md-chip md-chip-success"
                      >{{
                        requestCount('request')
                      }}</span>
                    </button>
                    <button
                      class="md-tab"
                      :class="{
                        'md-tab-inactive': activeTab !== 'offer',
                        'md-tab-active': activeTab === 'offer'
                      }"
                      @click="activeTab = 'offer'"
                    >
                      {{ $t('sector.tkliflr') }} <span
                        v-if="requestCount('offer')"
                        class="ml-2 md-chip md-chip-success"
                      >{{
                        requestCount('offer')
                      }}</span>
                    </button>
                    <button
                      class="md-tab"
                      :class="{
                        'md-tab-inactive': activeTab !== 'archive',
                        'md-tab-active': activeTab === 'archive'
                      }"
                      @click="activeTab = 'archive'"
                    >
                      {{ $t('sector.arxiv') }}
                    </button>
                  </div>
                </div>
              </div>

              <div
                v-if="requestList.length < 1"
                class="my-4 md-alert md-alert-info"
              >
                {{ $t('requestsByType.axtaraUyunSoruTaplmad') }}
              </div>

              <div class="md-card md-elevation-2">
                <div class="md-card-content">
                  <div
                    v-for="item in shuffledList"
                    :key="item.request?.id || item.product?.id"
                  >
                    <template v-if="item.type === 'request'">
                      <RequestItem
                        :active-tab="activeTab"
                        :is-archive="!available || activeTab === 'archive'"
                        :build-long-id="buildLongId(item.request.id)"
                        :r="item.request"
                        :sector="sector"
                      />
                    </template>
                    <template v-else>
                      <ProductItem :product="item.product" />
                    </template>
                    <div class="md-divider"></div>
                  </div>
                </div>
              </div>

              <div class="my-4 text-center">
                <button
                  v-if="activeTab === 'request'"
                  class="md-button md-button-outlined md-button-primary"
                  @click="activeTab = 'archive'"
                >
                  {{ $t('sector.arxivlnmiSorularaBax') }}
                </button>
              </div>
            </div>

            <div
              v-if="sector"
              class="col-lg-5"
            >
              <div class="md-card md-elevation-2">
                <div class="md-card-header">
                  {{ $t('sector.faliyytSahsiItiraklar') }}
                </div>
                <div
                  v-if="sector.description"
                  class="md-card-content"
                >
                  <p>{{ sector.description }}</p>
                </div>
                <div class="md-list">
                  <div
                    v-for="s in statistics"
                    :key="s.profileType"
                    class="md-list-item"
                    @click="showSectorCompanies(s.profileType)"
                  >
                    <div class="d-flex justify-content-between">
                      <div>
                        <span class="md-subtitle">{{ getProfileName(s.profileType) }}</span>
                      </div>
                      <div class="d-flex align-items-center">
                        <span>{{ $t('sector.istifadi', {counter: s.counter}) }}</span>
                        <feather
                          type="chevron-right"
                          size="20"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="profile === 'PROCUREMENT'">
                <div class="md-card md-elevation-2">
                  <div class="md-card-header">
                    {{ $t('requestsByType.tdarkTsdiqFormalar') }}
                  </div>
                  <div class="md-card-content">
                    <p>{{ $t('sector.sccPortalAdminiTrfindnRsmiTsdiqEdilmiSatnalanTkila') }}</p>

                    <p v-if="vendorManagementAvailable">
                      <router-link
                        class="md-button md-button-success"
                        :to="{ name: 'vendorManagementDashboard' }"
                      >
                        {{ $t('newInfoRequest.vendorManagement') }}
                      </router-link>
                    </p>
                    <p v-else>
                      <router-link
                        class="md-button md-button-success"
                        :to="{ name: 'addOnPage' }"
                      >
                        {{ $t('sector.vendorManagementiAktivldir') }}
                      </router-link>
                    </p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="md-card md-elevation-2">
                  <div class="md-card-header">
                    {{ $t('requestsByType.tdarkTsdiqFormalar') }}
                  </div>
                  <div class="md-card-content">
                    <p v-if="formList.length > 0">
                      {{ $t('requestsByType.satnalanTkilatlarnTsdiqlnmiTdarkSiyahsnaDmkNAadakT') }}
                    </p>

                    <p v-else>
                      {{ $t('sector.buSektordaHazrdaHeBirSatinalanTkilatnTdarkDyrlndir') }}
                    </p>
                  </div>
                </div>

                <div class="md-card md-elevation-2 mt-4">
                  <div
                    v-for="f in formsGrouped"
                    class="md-card-content"
                  >
                    <div
                      class="d-flex justify-content-between mt-2 cursor-pointer"
                      @click.prevent="openRatingPopup({ company: f.company, profile: 'PROCUREMENT' })"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          class="md-avatar mr-2"
                          :src="getPhoto(f.company.logo, 'thumbnailCropped')"
                          alt=""
                        >
                        <div class="about">
                          <div class="md-title">
                            {{ f.company.name }} {{ getCompanyFormat(f.company.format) }}
                          </div>
                          <div class="md-subtitle">
                            {{ $t('sector.ven', {taxId: f.company.taxId}) }}
                          </div>
                        </div>
                      </div>
                      <div>
                        <StarRatingView
                          :count="f.company.procurementRateCount"
                          :total="f.company.procurementRateTotal"
                          :single-star="true"
                        />
                      </div>
                    </div>

                    <div class="md-list mt-2 ml-2">
                      <router-link
                        v-for="fm in f.forms"
                        target="_blank"
                        :to="{ name: 'vendorFormView', params: { id: fm.id } }"
                        class="md-list-item d-flex justify-content-between align-items-center"
                      >
                        {{ fm.name }}
                        <i class="fa fa-chevron-right" />
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Container Ends-->
    </div>

    <b-modal
      id="modal-sector-statistics"
      centered
      :title="`${getProfileName(statisticsPopupProfile)} şirkətlər`"
      scrollable
      class="md-modal"
      :hide-footer="true"
    >
      <SectorCompaniesModalContent
        :sector="sector"
        :profile="statisticsPopupProfile"
        @openRatingPopup="openRatingPopup($event)"
      />
    </b-modal>

    <b-modal
      id="modal-company-rate-statists"
      centered
      :title="`${getProfileName(openCompanyRatingStatisticPopupProfile)} profili`"
      ok-only
      ok-title="bağla"
      class="md-modal"
      ok-variant="primary"
    >
      <CompanyRateStatistics
        v-if="openCompanyRatingStatisticPopup > 0"
        :show-company="true"
        :company-id="openCompanyRatingStatisticPopup"
        :profile-type="openCompanyRatingStatisticPopupProfile"
      />
    </b-modal>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import ActiveRequestsSidebar from '@/pages/scc/request/lists/ActiveRequestsSidebar.vue';
import {
  getSector,
  getSectorArchive,
  getSectorCountryNumber,
  getVendorManagementStatus,
  userAccounts,
} from '@/repositories/GeneralDataRepository';
import {mediaBase} from '@/repositories/Repository';
import {buildLongId, getCompanyFormat, getPhoto, getProfileName} from '@/repositories/Utils';
import RequestItem from '@/components/parts/RequestItem.vue';
import {getSectorForms} from '@/repositories/VendorManagementRepository';
import SectorCompaniesModalContent from '@/pages/scc/request/lists/SectorCompaniesModalContent.vue';
import CompanyRateStatistics from '@/pages/scc/company/CompanyRateStatistics.vue';
import StarRatingView from '@/pages/scc/utils/StarRatingView.vue';
import Multiselect from 'vue-multiselect';
import ProductItem from "@/pages/scc/products/ProductItem.vue";

export default {
  components: {
    Multiselect,
    ActiveRequestsSidebar,
    StarRatingView,
    CompanyRateStatistics,
    SectorCompaniesModalContent,
    RequestItem,
    ProductItem  // Register the new ProductItem component
  },
  data() {
    return {
      selectedCountry: [this.$t('countries.ALL')], // The selected country
      countryCodes: ['ALL'], // This will hold the corresponding country codes
      mediaBase: mediaBase,
      countryNumberCodes: null,
      profiles: [],
      dashboard: [],
      announcements: [],
      sector: {},
      statistics: [],
      requests: [],
      products: [],
      activeTab: 'request',
      available: false,
      requestTypeFilter: 'ALL',
      formList: [],
      statisticsPopupProfile: '',

      vendorManagementAvailable: false,

      openCompanyRatingStatisticPopup: 0,
      openCompanyRatingStatisticPopupProfile: '',
    };
  },
  computed: {
    ...mapState({
      token: (state) => state.auth.token,
      user: (state) => state.auth.user,
      company: (state) => state.auth.company,
      sessionType: (state) => state.auth.sessionType,
      profile: (state) => state.auth.profile,
      position: (state) => state.auth.position,
    }),
    countryOptions() {
      const countries = this.$t('countries'); // Fetches the countries translations based on the current locale
      return Object.keys(countries).map((code) => {
        return countries[code]; // The label that Vue Multiselect will display
      });
    },
    customLabel(option) {
      return option.name; // Return the name property to display the country name
    },
    requestList() {
      let list = [];
      this.requests.forEach((r) => {
        if (this.activeTab === 'offer') {
          if (r.requestType === 'OFR') {
            list.push(r);
          }
        } else if (this.activeTab === 'request') {
          if (r.requestType !== 'OFR' && (this.requestTypeFilter === 'ALL' || this.requestTypeFilter === r.requestType)) {
            list.push(r);
          }
        } else if (this.activeTab === 'archive') {
          if (r.requestType !== 'OFR' && (this.requestTypeFilter === 'ALL' || this.requestTypeFilter === r.requestType)) {
            list.push(r);
          }
        }
      });
      return list;
    },
    formsGrouped() {
      let list = {};

      this.formList.forEach((f) => {
        if (!list.hasOwnProperty(f.company.id)) {
          list[f.company.id] = {
            company: f.company,
            forms: [],
          };
        }

        list[f.company.id]['forms'].push(f);
      });

      return list;
    },
    shuffledList() {
      // Shuffle the products array
      let shuffledProducts = [...this.products];
      for (let i = shuffledProducts.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffledProducts[i], shuffledProducts[j]] = [shuffledProducts[j], shuffledProducts[i]];
      }

      // Interleave the requests and shuffled products
      let interleavedList = [];
      let requestIndex = 0;
      let productIndex = 0;

      while (requestIndex < this.requestList.length) {
        // Add up to 3 requests
        for (let i = 0; i < 3 && requestIndex < this.requestList.length; i++) {
          interleavedList.push({type: 'request', request: this.requestList[requestIndex]});
          requestIndex++;
        }

        // Add one product if available
        if (productIndex < shuffledProducts.length) {
          interleavedList.push({type: 'product', product: shuffledProducts[productIndex]});
          productIndex++;
        }
      }

      // If there are any remaining products, add them at the end
      while (productIndex < shuffledProducts.length) {
        interleavedList.push({type: 'product', product: shuffledProducts[productIndex]});
        productIndex++;
      }

      return interleavedList;
    },
  },
  watch: {
    token(newValue) {
      userAccounts(newValue).then((data) => {
        this.profiles = data;
      });
    },
    selectedCountry() {
      this.updateCountryCodes();
    },
    activeTab(newValue, oldValue) {
      if (newValue === 'archive') {
        this.requests = [];
        this.getArchiveList();
      } else {
        if (oldValue === 'archive') {
          this.requests = [];
          this.getNormalList();
        }
      }
    },
  },
  mounted() {
    this.getNormalList();
    this.getNumberOfCountryRequest();
    if (this.profile === 'SUPPLIER') {
      getSectorForms(this.token, this.$route.params['sectorId']).then((list) => {
        this.formList = list;
      });
    }

    getVendorManagementStatus(this.token).then(({code}) => {
      this.vendorManagementAvailable = code === 200;
    });
  },
  methods: {
    companyProfiles(companyId) {
      let list = [];
      this.profiles.forEach((p) => {
        if (p.company.id === companyId) {
          list.push(p);
        }
      });
      return list;
    },
    getCountryCode(countryName) {
      const countries = this.$t('countries'); // Assuming this gives an object like { az: "Azerbaijan", ... }
      // Find the country code by searching through the countries object
      const countryCode = Object.keys(countries).find((key) => countries[key] === countryName);
      return countryCode || null; // Return the country code if found, otherwise return null
    },
    updateCountryCodes() {
      this.countryCodes = this.selectedCountry.map((countryName) => this.getCountryCode(countryName));
      this.getNormalList();
    },
    updateCountryCodeNew(country) {
      this.countryCodes = [country];
      this.selectedCountry = this.$t('countries')[country];
      this.getNormalList();
    },
    getProfileName(keyword) {
      return getProfileName(keyword, this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPhoto(path, size) {
      return getPhoto(path, size);
    },
    requestCount(type) {
      let count = 0;
      this.requests.forEach((r) => {
        if (r.isRead < 1) {
          if (type === 'offer') {
            if (r.requestType === 'OFR') {
              count++;
            }
          } else {
            if (r.requestType !== 'OFR') {
              count++;
            }
          }
        }
      });
      return count;
    },
    getNumberOfCountryRequest() {
      getSectorCountryNumber(this.token, this.$route.params['sectorId'], this.$i18n.locale).then((data) => {
        if (data.code === 200) {
          this.countryNumberCodes = data.main;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error',
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },
    getNormalList() {
      getSector(this.token, this.$route.params['sectorId'], this.$i18n.locale, this.countryCodes).then((data) => {
        if (data.code === 200) {
          this.sector = data.sector;
          this.statistics = data.statistics;
          this.requests = data.requests;
          this.products = data.products;
          this.available = data.available || data.sector.logistic;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error',
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },
    getArchiveList() {
      getSectorArchive(this.token, this.$route.params['sectorId']).then((data) => {
        if (data.code === 200) {
          this.requests = data.requests;
        } else {
          this.$swal({
            title: `Error ${data.code}`,
            text: `${data.message}`,
            icon: 'error',
          }).then(() => {
            window.location.reload();
          });
        }
      });
    },
    showSectorCompanies(profile) {
      this.statisticsPopupProfile = profile;

      this.$bvModal.show('modal-sector-statistics');
    },
    openRatingPopup({company, profile}) {
      this.$bvModal.show('modal-company-rate-statists');
      this.openCompanyRatingStatisticPopup = company.id;
      this.openCompanyRatingStatisticPopupProfile = profile;
    },
  },
};
</script>

<style lang="scss" scoped>
// Material Design Variables
$md-primary: #1565C0;
$md-primary-dark: #0D47A1;
$md-primary-light: #90CAF9;
$md-secondary: #C2185B;
$md-success: #2E7D32;
$md-warning: #F57F17;
$md-error: #C62828;
$md-surface: #FFFFFF;
$md-background: #F5F5F5;
$md-on-primary: #FFFFFF;
$md-on-secondary: #FFFFFF;
$md-on-surface: #212121;
$md-on-background: #212121;

// Material Design Typography
$md-font-family: Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
$md-font-weight-regular: 400;
$md-font-weight-medium: 500;
$md-font-weight-bold: 700;

// Material Design Elevation
.md-elevation-2 {
  border-radius: 8px;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
  }
}

// Material Design Cards
.md-card {
  background-color: $md-surface;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 16px;
  font-family: $md-font-family;

  .md-card-header {
    padding: 16px;
    font-size: 18px;
    font-weight: $md-font-weight-medium;
    color: $md-on-surface;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    letter-spacing: 0.15px;
  }

  .md-card-content {
    padding: 16px;
    color: rgba($md-on-surface, 0.87);
    line-height: 1.5;
    letter-spacing: 0.25px;
  }
}

// Material Design Lists
.md-list {
  list-style: none;
  padding: 0;
  margin: 0;

  .md-list-item {
    padding: 12px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background-color: rgba($md-primary, 0.05);
    }
  }
}

// Material Design Divider
.md-divider {
  height: 1px;
  margin: 8px 0;
  background-color: rgba(0, 0, 0, 0.12);
}

// Material Design Avatar
.md-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}

// Material Design Typography
.md-title {
  font-size: 16px;
  font-weight: $md-font-weight-medium;
  color: $md-on-surface;
  letter-spacing: 0.15px;
  line-height: 1.5;
}

.md-subtitle {
  font-size: 14px;
  font-weight: $md-font-weight-regular;
  color: rgba($md-on-surface, 0.6);
  letter-spacing: 0.1px;
  line-height: 1.5;
}

// Material Design Tabs
.md-tab-group {
  display: flex;
  border-radius: 4px;
  overflow: hidden;
}

.md-tab {
  flex: 1;
  padding: 12px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: none;
  outline: none;
  font-family: $md-font-family;
  font-size: 14px;
  font-weight: $md-font-weight-medium;
  letter-spacing: 0.5px;

  &-active {
    background-color: $md-primary-dark;
    color: $md-on-primary;

    &:hover,
    &:focus,
    &:active {
      background-color: $md-primary-dark;
    }
  }

  &-inactive {
    background-color: rgba($md-primary-light, 0.2);
    color: $md-on-surface;

    &:hover {
      background-color: rgba($md-primary-light, 0.3);
    }
  }
}

// Material Design Chips
.md-chip {
  display: inline-flex;
  align-items: center;
  padding: 0 12px;
  height: 32px;
  font-size: 14px;
  font-weight: $md-font-weight-medium;
  border-radius: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &-success {
    background-color: $md-success;
    color: $md-on-primary;
  }
}

// Material Design Buttons
.md-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-width: 64px;
  height: 36px;
  padding: 0 16px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: $md-font-weight-medium;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  user-select: none;
  outline: none;
  border: none;

  &-primary {
    color: $md-primary;
  }

  &-success {
    color: $md-success;
  }

  &-outlined {
    border: 1px solid currentColor;
    background-color: transparent;

    &:hover {
      background-color: rgba($md-primary, 0.08);
    }
  }

  &-contained {
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);

    &:hover {
      box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
    }

    &.md-button-primary {
      background-color: $md-primary;
      color: $md-on-primary;
    }

    &.md-button-success {
      background-color: $md-success;
      color: $md-on-primary;
    }
  }
}

// Material Design Alert
.md-alert {
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-family: $md-font-family;

  &-info {
    background-color: rgba($md-primary-light, 0.2);
    color: $md-primary-dark;
    border-left: 4px solid $md-primary;
  }
}

// Material Design Select
.md-select-container {
  position: relative;
  margin-bottom: 16px;
}

.md-select {
  width: 100%;
  height: 40px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background-color: $md-surface;
  font-family: $md-font-family;
  font-size: 16px;
  color: $md-on-surface;
  transition: border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  outline: none;

  &:focus {
    border-color: $md-primary;
    box-shadow: 0 0 0 2px rgba($md-primary, 0.2);
  }

  &::placeholder {
    color: rgba($md-on-surface, 0.6);
  }
}

// Override Multiselect styles to match Material Design
::v-deep .multiselect {
  min-height: 40px;
  border-radius: 4px;
  font-family: $md-font-family;

  .multiselect__tags {
    min-height: 40px;
    padding: 8px 40px 0 12px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    font-family: $md-font-family;
    background-color: $md-surface;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      border-color: rgba(0, 0, 0, 0.24);
    }
  }

  .multiselect__placeholder {
    margin-bottom: 8px;
    padding-top: 0;
    color: rgba($md-on-surface, 0.6);
    font-size: 14px;
  }

  .multiselect__input, .multiselect__single {
    font-size: 16px;
    color: $md-on-surface;
    margin-bottom: 8px;
    padding: 0;
    background-color: transparent;
    line-height: 1.5;
  }

  .multiselect__select {
    height: 40px;
    width: 40px;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:before {
      border-color: $md-primary transparent transparent;
      border-width: 5px 5px 0;
      margin-top: -2px;
    }
  }

  &.multiselect--active {
    .multiselect__tags {
      border-color: $md-primary;
      box-shadow: 0 0 0 2px rgba($md-primary, 0.2);
    }

    .multiselect__select {
      transform: rotate(180deg);
    }
  }

  .multiselect__tag {
    background-color: $md-primary;
    color: $md-on-primary;
    border-radius: 16px;
    margin-right: 8px;
    margin-bottom: 4px;
    padding: 4px 26px 4px 10px;
    font-size: 14px;
    font-weight: $md-font-weight-medium;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    height: 32px;
    display: inline-flex;
    align-items: center;

    i {
      margin-left: 8px;
      border-radius: 50%;
      color: $md-on-primary;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background-color: darken($md-primary, 10%);
      }

      &:after {
        font-size: 16px;
        content: "\00d7";
        color: $md-on-primary;
      }
    }
  }

  .multiselect__spinner {
    background: $md-surface;
    height: 38px;
    width: 38px;

    &:before, &:after {
      border-color: $md-primary transparent transparent;
    }
  }

  .multiselect__option {
    font-family: $md-font-family;
    padding: 12px 16px;
    min-height: 40px;
    line-height: 1.5;
    font-size: 14px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    align-items: center;

    &--highlight {
      background-color: rgba($md-primary, 0.1);
      color: $md-primary;

      &:after {
        background-color: $md-primary;
        color: $md-on-primary;
        font-weight: $md-font-weight-medium;
        padding: 8px 16px;
        font-size: 14px;
      }
    }

    &--selected {
      background-color: rgba($md-primary, 0.05);
      color: $md-on-surface;
      font-weight: $md-font-weight-medium;

      &.multiselect__option--highlight {
        background-color: rgba($md-primary, 0.1);
        color: $md-primary;
      }
    }
  }

  .multiselect__content-wrapper {
    border-radius: 0 0 4px 4px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-top: none;
    background-color: $md-surface;
    box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
    margin-top: -1px;
  }

  .multiselect__clear {
    position: absolute;
    right: 40px;
    top: 8px;
    height: 24px;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: transparent;
    transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    cursor: pointer;

    &:hover {
      background-color: rgba(0, 0, 0, 0.08);
    }

    &:before, &:after {
      content: '';
      position: absolute;
      width: 2px;
      height: 12px;
      background-color: rgba($md-on-surface, 0.6);
      transform: rotate(45deg);
    }

    &:after {
      transform: rotate(-45deg);
    }
  }
}

// Material Design Modal
::v-deep .md-modal {
  .modal-content {
    border-radius: 8px;
    border: none;
    box-shadow: 0 11px 15px -7px rgba(0,0,0,.2), 0 24px 38px 3px rgba(0,0,0,.14), 0 9px 46px 8px rgba(0,0,0,.12);
    overflow: hidden;
  }

  .modal-header {
    padding: 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    .modal-title {
      font-family: $md-font-family;
      font-size: 20px;
      font-weight: $md-font-weight-medium;
      color: $md-on-surface;
      letter-spacing: 0.15px;
    }

    .close {
      width: 40px;
      height: 40px;
      margin: -16px -16px -16px auto;
      padding: 8px;
      border-radius: 50%;
      transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background-color: rgba(0, 0, 0, 0.08);
      }

      span {
        font-size: 24px;
        color: rgba($md-on-surface, 0.6);
      }
    }
  }

  .modal-body {
    padding: 16px;
    font-family: $md-font-family;
    color: rgba($md-on-surface, 0.87);
    line-height: 1.5;
    letter-spacing: 0.25px;
  }

  .modal-footer {
    padding: 8px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.12);

    .btn-primary {
      background-color: $md-primary;
      border-color: $md-primary;
      color: $md-on-primary;
      border-radius: 4px;
      font-family: $md-font-family;
      font-size: 14px;
      font-weight: $md-font-weight-medium;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      padding: 8px 16px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);

      &:hover {
        background-color: darken($md-primary, 10%);
        border-color: darken($md-primary, 10%);
        box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
      }

      &:focus, &:active {
        box-shadow: 0 0 0 0.2rem rgba($md-primary, 0.5);
      }
    }

    .btn-secondary {
      background-color: transparent;
      border-color: transparent;
      color: $md-primary;
      border-radius: 4px;
      font-family: $md-font-family;
      font-size: 14px;
      font-weight: $md-font-weight-medium;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      padding: 8px 16px;
      transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background-color: rgba($md-primary, 0.08);
      }

      &:focus, &:active {
        box-shadow: 0 0 0 0.2rem rgba($md-primary, 0.25);
      }
    }
  }
}

// Responsive Design
@media (max-width: 768px) {
  .md-card {
    margin-bottom: 16px;
  }

  .md-tab {
    padding: 8px;
    font-size: 12px;
  }

  .md-list-item {
    .d-flex {
      flex-direction: column;
      align-items: flex-start !important;

      > div:last-child {
        margin-top: 8px;
        width: 100%;
      }
    }
  }

  .md-select-container {
    margin-bottom: 8px;
  }

  .md-select {
    height: 36px;
    font-size: 14px;
  }
}
</style>
